import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorMessageEnum } from '../models/enum/error-msg-enum';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

export const errorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  let toast = inject(ToastrService);
  let spinner = inject(NgxSpinnerService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error instanceof HttpErrorResponse) {
        let message: string = ErrorMessageEnum.DEFAULT;

        switch (error.status) {
          case 400:
            message = ErrorMessageEnum.BAD_REQUEST;
            break;
          case 401:
            message = ErrorMessageEnum.UNAUTHORIZED;
            break;
          case 403:
            message = ErrorMessageEnum.FORBIDDEN;
            break;
          case 404:
            message = ErrorMessageEnum.NOT_FOUND;
            break;
          case 409:
            message = ErrorMessageEnum.USER_DUPLICATED;
            break;
          case 500:
            message = ErrorMessageEnum.INTERNAL_SERVER;
            break;
          default:
            message = `สถานะ ${error.status}: ${error.statusText}`;
            break;
        }

        toast.error(message, 'ขออภัยเกิดข้อผิดพลาด', {
          timeOut: 2500,
          progressBar: true,
        });

        if (spinner) {
          spinner.hide();
        }
      }
      return throwError(() => error);
    })
  );
};
